<template>
  <div class="content-grid" :style="gridStyle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'dx-grid',

  props: {
    columns: {
      type: Number,
      required: true,
    },
    gap: {
      type: Number,
      default: 0,
    },
    rowGap: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    gridStyle() {
      return {
        'grid-template-columns': `repeat(${this.columns}, 1fr)`,
        gap: `${this.gap}px`,
        'row-gap': `${this.rowGap}px`,
      };
    },
  },
};

</script>

<style scoped>
  .content-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
</style>
